/**
 * File back-to-top.js.
 *
 * This script manages the behavior of the back-to-top button.
 * It monitors the user's scroll position, displaying the button
 * when the scroll position exceeds a certain threshold. Clicking
 * the button scrolls the window smoothly to the top.
 */
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const backToTopButton = document.querySelector(".back-to-top");

    if (backToTopButton) {
      let isScrolling = false;

      function throttleScroll() {
        if (!isScrolling) {
          window.requestAnimationFrame(() => {
            if (window.scrollY > 300) {
              backToTopButton.style.display = "";
            } else {
              backToTopButton.style.display = "none";
            }
            isScrolling = false;
          });
        }
        isScrolling = true;
      }

      window.addEventListener("scroll", throttleScroll);

      backToTopButton.addEventListener("click", () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }
  });
})();
